import { render, staticRenderFns } from "./ArticleDemandList.vue?vue&type=template&id=7ef03932&scoped=true&"
import script from "./ArticleDemandList.vue?vue&type=script&lang=ts&"
export * from "./ArticleDemandList.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleDemandList.vue?vue&type=style&index=0&id=7ef03932&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef03932",
  null
  
)

export default component.exports